<!--
 * @Description: 开票维护-分类
 * @Date: 2025-05-20 15:57:04
-->

<template>
  <BaseForm
    class="invoice-enterprise-dialog-category"
    ref="formRef"
    label-position="top"
    :model="formData"
  >
    <div class="form-dialog__title">
      <h1>发票类目</h1>
      <!-- <BaseButton size="small" :click="onSave">
        {{ disabled ? '编辑' : '保存' }}
      </BaseButton> -->
      <BaseButton
        size="small"
        type="primary2"
        v-if="!disabled && formData.length < 20"
        @click="onShowAddInput"
      >
        新增
      </BaseButton>
    </div>
    <BaseFormItem prop="id" label="&nbsp" style="margin-top: -30px">
      <div style="display: flex; align-items: center; flex-wrap: wrap">
        <BaseTag
          style="margin-right: 8px; margin-bottom: 15px"
          v-for="(tag, index) in formData"
          :key="tag.id"
          :closable="!disabled"
          @close="onRemove(index)"
        >
          <div style="display: flex; align-items: center">
            <span v-if="index !== editInfo.index">{{ tag.itemName }}</span>
            <BaseInput
              v-else
              type="text"
              :min="1"
              :max="10"
              v-model="editInfo.value"
              @keyup.enter="onBlurTag"
              @blur="onBlurTag"
            />
            <BaseIcon
              v-if="!disabled"
              style="font-size: 32px; margin-left: 10px"
              @click="onShowInput(index)"
            >
              <Edit></Edit>
            </BaseIcon>
          </div>
        </BaseTag>
        <BaseTag
          v-if="inputVisible"
          style="margin-right: 8px; margin-bottom: 15px"
          :closable="false"
        >
          <BaseInput
            ref="inputRef"
            size="small"
            v-model="inputValue"
            @keyup.enter="onInputConfirm"
            @blur="onInputConfirm"
          />
        </BaseTag>
      </div>
    </BaseFormItem>
  </BaseForm>
</template>

<script lang="tsx" name="invoice-enterprise-dialog-category" setup>
import { ref, nextTick, watchEffect } from 'vue';
import {
  BaseTag,
  BaseButton,
  BaseForm,
  BaseFormItem,
  BaseInput,
  BaseIcon
} from 'xrk-components';
import { BasicInformationData } from '@V/invoice/src/data-source/types';
import {
  deleteInvoiceCate,
  editInvoiceCate
} from '@V/invoice/src/data-source/apis';
import { Edit } from '@element-plus/icons-vue';

type ItemList = BasicInformationData['itemList'];

const props = withDefaults(
  defineProps<{
    remove?: () => {};
    value: ItemList;
  }>(),
  {
    remove() {
      return () => {
        console.log('remove');
      };
    }
  }
);

const formData = ref<ItemList>(props.value || []);
const inputValue = ref('');
const inputVisible = ref(false);
const inputRef = ref(null);
const disabled = ref(false); // false可编辑并按钮变为保存
const editInfo = ref({
  index: -1,
  value: ''
});

watchEffect(() => {
  formData.value = props.value || [];
});

const onShowAddInput = () => {
  inputVisible.value = true;
  nextTick(() => {
    inputRef.value?.focus();
  });
};

const onShowInput = index => {
  editInfo.value.index = index;
  editInfo.value.value = formData.value[index].itemName;
};
const onBlurTag = async () => {
  // 有输入值，则修改formData
  if (editInfo.value.value) {
    const curData = formData.value[editInfo.value.index];
    curData.itemName = editInfo.value.value;
    editInvoiceCate({
      id: curData.id,
      itemName: curData.itemName
    });
  }
  editInfo.value.index = -1;
};
const onRemove = async (index: number) => {
  editInfo.value.index = -1;
  await deleteInvoiceCate({ id: formData.value[index].id });
  formData.value.splice(index, 1);
};
const onInputConfirm = async () => {
  if (inputValue.value) {
    const { data } = await editInvoiceCate({
      itemName: inputValue.value
    });
    formData.value.push({ id: data, itemName: inputValue.value });
  }
  inputVisible.value = false;
  inputValue.value = '';
};
// const onSave = async () => {
//   // 保存
//   if (!disabled.value) {
//     console.log('save');
//   }
//   disabled.value = !disabled.value;
// };
</script>
<style lang="scss" scoped>
.invoice-enterprise-dialog-category {
  ::v-deep {
    .xrk-tag__content .xrk-input__wrapper {
      height: 24px;
      box-shadow: none;
    }
  }
}
</style>
